import React, { useEffect, useMemo, useState } from 'react'
import { useLocalStorage } from 'react-use'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'

import Popup from '../popup'
import Button from '../form/fields/button'
import CTA from '../mdx/link/cta'
import Link from '../mdx/link/link-renderer'

import { t } from '@lingui/macro'

import { useLingui } from '@lingui/react'

import { useIdle } from 'react-use'
import { useTrackPromotionEvent } from '../../hooks/tracking'

const PopUp = ({ pageContext }) => {
  const { i18n } = useLingui()
  const trackPromotion = useTrackPromotionEvent()
  const popupResults = useStaticQuery(graphql`
    query Popup {
      allContentfulContentTypeBlogPost(
        filter: {
          popupStart: { ne: null }
          popupEnd: { ne: null }
          popupImage: { id: { ne: null } }
        }
        sort: { popupStart: DESC }
      ) {
        nodes {
          title
          sys {
            id
            locale
          }
          popupStart
          popupEnd
          popupImage {
            gatsbyImageData(
              width: 560
              placeholder: BLURRED
              breakpoints: [280, 420, 560, 1120]
              sizes: "(max-width: 670px) calc(100vw - 64px - 16px - 2rem), 560px"
              quality: 40
              formats: [WEBP, JPG]
            )
          }
        }
      }
    }
  `)

  // Loop through results and find first that should be active right now and locale matches
  const activePopup = useMemo(
    () =>
      popupResults.allContentfulContentTypeBlogPost.nodes.find(
        ({
          popupStart,
          popupEnd,

          sys: { locale: node_locale },
        }) => {
          if (node_locale !== pageContext.locale) {
            return false
          }
          const start = Date.parse(popupStart)
          const end = Date.parse(popupEnd)
          const now = Date.now()
          return start <= now && end >= now
        }
      ),
    [popupResults, pageContext.locale]
  )
  const [popupShown, setPopupShown] = useLocalStorage(
    `popup-${activePopup?.sys.id}`,
    0
  )
  const [popupOpen, setPopupOpen] = useState(false)

  const isIdling = useIdle(5000)

  useEffect(() => {
    if (
      activePopup &&
      isIdling &&
      // Show popup only every 8 hours and only once to the user
      (!popupShown || popupShown <= Date.now() - 8 * 60 * 60 * 1000)
    ) {
      setPopupOpen(true)
      setPopupShown(Date.now())
    }
  }, [activePopup, setPopupOpen, setPopupShown, popupShown, isIdling])

  if (!activePopup) {
    return null
  }

  return (
    <Popup
      isOpen={popupOpen}
      setIsOpen={setPopupOpen}
      title={`Popup: ${activePopup.title}`}
    >
      <Link id={activePopup.sys.id} onClick={() => {
          trackPromotion('Popup Click', activePopup.title)
          setPopupOpen(false)
        }}>
        <GatsbyImage
          image={activePopup.popupImage.gatsbyImageData}
          alt={activePopup.title}
          loading="eager"
          fetchpriority="high"
        />
      </Link>
      <div className="mt-8 flex flex-row-reverse justify-between">
        <CTA
          id={activePopup.sys.id}
          onClick={() => {
            trackPromotion('Popup Click', activePopup.title)
            setPopupOpen(false)
          }}
          data-button-style="primary"
        >
          {t(i18n)`Read more...`}
        </CTA>
        <Button onClick={() => setPopupOpen(false)}>{t(i18n)`Close...`}</Button>
      </div>
    </Popup>
  )
}

export default PopUp
